import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["style", "className"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { useStyles, StyleSheet, padding, border } from '@rexlabs/styling';
import { Tag, TagGroup } from '@rexlabs/tag';
import { useSelect } from '../hooks/use-select';
var defaultStyles = StyleSheet({
  container: _objectSpread({}, padding.styles({
    target: 'select.tags.container',
    all: 'xs'
  })),
  divider: _objectSpread({}, border.styles({
    target: 'select.tags.container',
    bottom: {
      width: 'thin',
      color: 'container.static.light'
    }
  }))
});
export var SelectedTags = /*#__PURE__*/forwardRef(function SelectedTags(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      selectedItems = _useSelect.selectedItems,
      deselectItem = _useSelect.deselectItem,
      getItemId = _useSelect.getItemId,
      itemToString = _useSelect.itemToString;

  return /*#__PURE__*/React.createElement(TagGroup, _extends({}, props, s.with('container', 'divider')({
    style: style,
    className: className
  }), {
    ref: ref,
    size: "s",
    tabIndex: -1
  }), _mapInstanceProperty(selectedItems).call(selectedItems, function (item, index) {
    var _getItemId;

    return /*#__PURE__*/React.createElement(Tag, {
      key: (_getItemId = getItemId(item)) !== null && _getItemId !== void 0 ? _getItemId : index,
      handleClear: function handleClear() {
        deselectItem(item);
      }
    }, itemToString(item));
  }));
});